import React, { useState } from 'react'
import { DropdownPill, DropdownPillSyncProps } from 'components/common/dropdown_pill/DropdownPill'
import withRadioGroup from 'components/fields/withRadioGroup'

const ReplySelectionMap = {
  all: 'Replies',
  withReplies: 'With Replies',
  withoutReplies: 'Without Replies'
} as const
export type ReplySelectionMapKey = keyof typeof ReplySelectionMap

interface SupplierReplyFilterBaseProps {
  onChange: (selection: ReplySelectionMapKey) => void
}

type SupplierReplyFilterProps = SupplierReplyFilterBaseProps & Partial<DropdownPillSyncProps>

const ReplyFilterItem = withRadioGroup('reply')

export const SupplierReplyFilter: React.FC<SupplierReplyFilterProps> = ({ onChange, ...dropdownProps }) => {
  const [selection, setSelection] = useState<ReplySelectionMapKey>('all')

  const label = ReplySelectionMap[selection]

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selection = (e.target.value in ReplySelectionMap) ? e.target.value as ReplySelectionMapKey : 'all'
    setSelection(selection)
    onChange(selection)
  }

  const syncProps: DropdownPillSyncProps = {
    id: dropdownProps.id ?? 'none',
    isExpanded: dropdownProps.isExpanded ?? false,
    onClick: dropdownProps.onClick ?? (() => { console.error('Dropdown onClick handler not set') })
  }

  return (
    <DropdownPill labelText={label} {...syncProps}>
      <div className='supplier-reply-filters review-filter' onChange={handleChange}>
        <ReplyFilterItem label='All Reply Types' optionValue='all' selectedValue={selection} />
        <ReplyFilterItem label='With Replies' optionValue='withReplies' selectedValue={selection} />
        <ReplyFilterItem label='Without Replies' optionValue='withoutReplies' selectedValue={selection} />
      </div>
    </DropdownPill>
  )
}
